/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, Input, Output, EventEmitter, OnInit} from "@angular/core";
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {Observable, Observer} from 'rxjs';

import {EntityService} from "../../../../services/entity.service";
import {UserGroupService} from "../../../../services/user-group.service";

import {Group} from "../../../../models/group";
import {InstanceData} from "../../../../models/instance-data";
import { switchMap } from "rxjs/operators";

@Component({
  selector: 'app-user-group-selector',
  templateUrl: './user-group-selector.component.html'
})
export class UserGroupSelectorComponent implements OnInit {

  @Input()
  mData: InstanceData;

  @Output()
  removeClicked = new EventEmitter<void>();

  typeaheadValue: string;
  typeaheadLoading: boolean;
  typeaheadNoResults: boolean;
  entities: Observable<any>;  

  constructor(
	private mGroupService: UserGroupService,
	private mEntityService: EntityService
  ) {}

  ngOnInit(): void {
    //KHT 08/17/2021 - updated to new ngx-bootstrap standard
    this.entities = new Observable((observer: Observer<string>) => {
      observer.next(this.typeaheadValue);
    }).pipe(
      switchMap((query: string) => {
        if (query) {
          return this.search(query);
        }
      })
    )

	this.loadGroup();
  }

  changeTypeaheadLoading(e: boolean): void {
    this.typeaheadLoading = e;
  }

  typeaheadOnSelect(e: TypeaheadMatch): void {
    this.mData.value = e.item.id;

	if (this.mData.object_value != null) {
		this.mData.object_value.group_reference.id = e.item.id;
	}
  }

  private search(token: string): Observable<any[]> {
	return this.mGroupService.search(token);
  }

  private async loadGroup(): Promise<void> {
	const group: Group = await this.mGroupService.getUserGroup(Number(this.mData.value));
	if (group != null) {
		this.typeaheadValue = group.name;
	}
  }

}
